'use client'

import { useEffect, useState } from 'react'

interface VideoState {
	element: HTMLVideoElement
	isPlaying: boolean
	isMuted: boolean
	isLooping: boolean
}

export default function DevHelperMediaStatus({}) {
	const [mediaStatusOn, setMediaStatusOn] = useState(false)
	const [videoStates, setVideoStates] = useState<VideoState[]>([])

	useEffect(() => {
		function listenForShortcut(event: KeyboardEvent) {
			if (event.code == 'KeyM' && event.altKey) {
				if (mediaStatusOn) {
					setMediaStatusOn(false)
				} else {
					setMediaStatusOn(true)
				}
			}
		}
		window.addEventListener('keyup', listenForShortcut, false)
		return () => window.removeEventListener('keyup', listenForShortcut, false)
	}, [mediaStatusOn])

	useEffect(() => {
		if (!mediaStatusOn) return

		// Find all video elements
		const videoElements = document.querySelectorAll('video')
		const states: VideoState[] = []

		videoElements.forEach((video) => {
			const state: VideoState = {
				element: video,
				isPlaying: !video.paused,
				isMuted: video.muted,
				isLooping: video.loop
			}
			states.push(state)

			// Add event listeners to track state changes
			const updateState = () => {
				setVideoStates(prev => prev.map(s =>
					s.element === video
						? { ...s, isPlaying: !video.paused, isMuted: video.muted, isLooping: video.loop }
						: s
				))
			}

			video.addEventListener('play', updateState)
			video.addEventListener('pause', updateState)
			video.addEventListener('volumechange', updateState)
			video.addEventListener('ratechange', updateState)
		})

		setVideoStates(states)

		// Cleanup event listeners
		return () => {
			videoElements.forEach((video) => {
				video.removeEventListener('play', () => {})
				video.removeEventListener('pause', () => {})
				video.removeEventListener('volumechange', () => {})
				video.removeEventListener('ratechange', () => {})
			})
		}
	}, [mediaStatusOn])

	useEffect(() => {
		if (!mediaStatusOn) return

		// Insert status divs after video elements
		videoStates.forEach((state) => {
			// console.log('state:', state)
			const existingStatus = state.element.nextElementSibling?.classList.contains('video-status-debug')
			if (!existingStatus) {
				const statusDiv = document.createElement('div')
				statusDiv.className = 'absolute top-0 left-0 flex flex-col gap-2 video-status-debug fixed z-[999998] bg-error/95 text-white text-sm p-8 pointer-events-none'
				statusDiv.innerHTML = `
					<div>Playing: ${state.isPlaying ? '✅' : '❌'}</div>
					<div>Muted: ${state.isMuted ? '✅' : '❌'}</div>
					<div>Loop: ${state.isLooping ? '✅' : '❌'}</div>
				`
				state.element.parentNode?.insertBefore(statusDiv, state.element.nextSibling)
			}
		})

		// Cleanup status divs when component unmounts or mediaStatusOn changes
		return () => {
			document.querySelectorAll('.video-status-debug').forEach(el => el.remove())
		}
	}, [videoStates, mediaStatusOn])

	if (!mediaStatusOn) return null
}
